<template>
  <el-dialog :visible.sync="showModal" :title="'添加选项'" append-to-body>
    <el-form :model="form" :rules="rules" label-width="100px" ref="form">
      <el-form-item label="排序号" prop="sortNum">
        <el-input v-model.number="form.sortNum" placeholder="不设置时,默认按照A,B,C,D,E排序;若设置排序,按照正序排序;" />
      </el-form-item>
      <el-form-item label="选项" prop="optionName">
        <el-row>
          <el-col :span="3">
            <el-select v-model="form.optionName">
              <el-option :label="item" :value="item" v-for="(item,index) in optionData" :key="index"></el-option>
            </el-select>
          </el-col>
          <!-- <el-col :span="21">
            <el-input placeholder="请填写选项内容" v-model="form.optionName" />
          </el-col> -->
        </el-row>
      </el-form-item>
      <el-form-item label="选项内容" prop="optionDescribe">
        <!-- <QuillEditor v-model="form.optionDescribe" @getText="getoptionDescribe" ref="QuillEditor" /> -->
        <el-input type="textarea" rows="4" v-model="form.optionDescribe" placeholder="请输入选项内容" />
      </el-form-item>
      <el-form-item label="备注" prop="remarks">
        <el-input v-model.trim="form.remarks" placeholder="请输入备注" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="showModal = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { courseTypeList, optionData } from "../../dict"
import { examOptionAdd, examOptionUpdate } from "../../api"
const rules = {
  optionName: [
    { required: true, message: '请选择选项', trigger: 'change' },
  ],
  optionDescribe: [
    { required: true, message: '请输入选项内容', trigger: 'blur' },
  ]
}
export default {
  components: {},
  data () {
    return {
      courseTypeList,
      optionData,
      rules,
      showModal: false,
      form: {
        sortNum: null,
        optionDescribe: null,
        optionName: null,
        remarks: null
      },
      id: null,
      optionId: null
    }
  },
  watch: {
    showModal: {
      handler (value) {
        if (!value) {
          this.$refs['form'].resetFields()
        }
      }
    }
  },
  methods: {
    getoptionDescribe (value) {
      this.form.getoptionDescribe = value
    },
    init ({ examTopicId, optionId, item }) {
      this.showModal = true
      // this.form = this.$data.form
      setTimeout(() => {
        this.$refs.form.resetFields()
        this.id = examTopicId
        this.optionId = optionId
        if (item) {
          Object.keys(this.form).forEach(key => {
            this.form[key] = item[key]
          })
        }
      }, 100);
    },
    submit () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const params = { ...this.form }
          params.examTopicId = this.id
          if (this.optionId) {
            params.id = this.optionId
            const res = await examOptionUpdate(params)
            if (res.code !== 0) return this.$message.warning(res.message)
            this.$message.success('操作成功！')
            this.showModal = false
            this.$emit('update', true)
          } else {
            const res = await examOptionAdd(params)
            if (res.code !== 0) return this.$message.warning(res.message)
            this.$message.success('操作成功！')
            this.showModal = false
            this.$emit('update', true)
          }

        } else {
          return false;
        }
      });

    }
  }
}
</script>

<style>
</style>